import SButton from "components/Common/Button"
import SelectBox from "components/Common/SelectBox"
import BranchesAPI from "helpers/branches_backend_helper"
import { getCommonTaxAPI } from "helpers/common"
import CompanyAPI from "helpers/company_backend_helper"
import {
  getFabricListAPI,
  getFabricRankAPI,
  getFabricSeasonListAPI,
  getFabricYearListAPI,
} from "helpers/fabric_resource"
import { getFabricTradingListAPI } from "helpers/fabric_trading_company_resource"
import {
  getEditOrderAPI,
  patchCancelOrder,
  getPrintOrder,
  getFileCategoryApi,
  postUpdateOrderApi,
} from "helpers/order"
import {
  getInspectionHistoryApi,
  getPaymentMethods,
  shipOrderApi,
} from "helpers/order_edit_resource"
import { getProductCategoryListAPI } from "helpers/product_category_helper"
import React, { useEffect, useState, useCallback, useRef } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal as ReactStrapModal,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import JacketTab from "./JacketTab"
import TrousersTab from "./TrousersTab"
import Breadcrumb from "components/Common/Breadcrumb"
import TabHandwritingNotebook from "./TabHandwritingNotebook"
import { getProductListAPI, getProductTgType } from "helpers/product_helper"
import TabInspectionHistory from "./TabInspectionHistory"
import { useHistory } from "react-router-dom"
import FileManagerModal from "components/Common/FileManagerModal"
import { toast } from "react-toastify"
import moment from "moment"

export default function OrdersEdit() {
  const history = useHistory()
  const initialPayload = {
    storeId: 0,
    customerId: 0,
    type: "Bespoke",
    files: [],
    productId: 0,
    orderDate: "",
    guest: true,
    guestId: 0,
    guestName: "",
    fabricCompanyId: "",
    year: 0,
    seasonId: "",
    fabricId: "",
    fittingDate: "",
    basting: true,
    memo: "",
    jacket: {
      scale: 0,
      priceWithoutTax: 0,
      priceTaxIncluded: 0,
      deliveryMethod: "",
      sample: false,
      scheduledDeliveryDate: "",
      oldAge: 0,
      tg: "",
      payments: [
        // {
        //   id: 0,
        //   paymentDate: "",
        //   paymentMethodId: 0,
        //   amount: 0,
        // },
      ],
      specifications: [
        {
          formId: 0,
          sequence: 0,
          answers: [
            {
              sequence: 0,
              answer: "",
            },
          ],
        },
      ],
      dimensions: [
        {
          formId: 0,
          sequence: 0,
          gaugeDimensions: "",
          correctionValue: "",
          lawToGoUp: "",
        },
      ],
      otherDimensions: [
        {
          formId: 0,
          sequence: 0,
          answer: "",
        },
      ],
    },
    pants: {
      scale: 0,
      priceWithoutTax: 0,
      priceTaxIncluded: 0,
      deliveryMethod: "string",
      sample: true,
      scheduledDeliveryDate: "2023-03-13",
      oldAge: 0,
      tg: "",
      payments: [
        // {
        //   id: 0,
        //   paymentDate: "2023-03-13",
        //   paymentMethodId: 0,
        //   amount: 0,
        // },
      ],
      button: "string",
      threadColor: "string",
      specifications: [
        {
          formId: 0,
          sequence: 0,
          answers: [
            {
              sequence: 0,
              answer: "string",
            },
          ],
        },
      ],
      dimensions: [
        {
          formId: 0,
          sequence: 0,
          nude: "string",
          correctionValue: "string",
          riseDimension: "string",
        },
      ],
      corrections: [
        {
          formId: 0,
          sequence: 0,
          answers: [
            {
              sequence: 0,
              answer: "string",
            },
          ],
        },
      ],
    },
  }
  const defaultSelectValue = { value: "", label: "" }
  const [productData, setProductData] = useState(null)
  const [payload, setPayload] = useState(initialPayload)
  // select value;
  const [guestDisabled, setGuestDisabled] = useState(false)
  const [branch, setBranch] = useState(defaultSelectValue)
  const [customerId, setCustomerId] = useState(defaultSelectValue)
  const [fabricTrading, setFabricTrading] = useState(defaultSelectValue)
  const [fabric, setFabric] = useState(defaultSelectValue)
  const [year, setYear] = useState(defaultSelectValue)
  const [season, setSeason] = useState(defaultSelectValue)
  const [paymentMethod, setPaymentMethod] = useState(defaultSelectValue)
  const [deliveryMethodValue, setDeliveryMethodValue] =
    useState(defaultSelectValue)
  const [pantsDeliveryMethod, setPantsDeliveryMethod] =
    useState(defaultSelectValue)
  const [jacketDeliveryMethod, setJacketDeliveryMethod] =
    useState(defaultSelectValue)
  const [inspectionData, setInspectionData] = useState(null)
  const [categories, setCategories] = useState([])
  const [products, setProducts] = useState([])
  // select options
  const [branches, setBranches] = useState([])
  const [customers, setCustomers] = useState([])
  const [customerIds, setCustomerIds] = useState([])
  const [fabricTradings, setFabricTradings] = useState([])
  const [fabrics, setFabrics] = useState([])
  const [years, setYears] = useState([])
  const [seasons, setSeasons] = useState([])
  const [paymentMethods, setPaymentMethods] = useState([])
  const [canvas, setCanvas] = useState([])
  const [trigger, setTriger] = useState(0)
  const [tax, setTax] = useState(0)
  const [rank, setRank] = useState(null)
  const [guestHidden, setGuestHidden] = useState(1)
  const [tabs, setTabs] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const params = new URLSearchParams(location.search)
  const id = params.get("id")
  const getCanvasRef = useRef()
  const [fileModalOpen, setFileModalOpen] = useState(false)
  const openFileModal = useCallback(() => setFileModalOpen(true), [])
  const closeFileModal = useCallback(() => setFileModalOpen(false), [])
  const [fileCategoryOptions, setFileCategoryOptions] = useState([])
  const [fileCategoryValue, setFileCategoryValue] = useState("")
  const [file, setFile] = useState(null)
  console.log(payload)

  const constructAnswers = items => {
    return items
      .filter(item => item.formId)
      .map(item => ({
        formId: item.formId,
        sequence: item.sequence,
        answers: item.answers?.length
          ? item.answers
              .filter(ans => ans.answer)
              .map(ans => ({
                sequence: ans.sequence,
                answer: ans.answer || "",
              }))
          : "",
      }))
  }
  const constructPayload = apiData => {
    const {
      basting,
      customerId,
      fabricCompanyId,
      fabricId,
      fittingDate,
      guest,
      files,
      guestId,
      guestName,
      orderDate,
      productId,
      seasonId,
      storeId,
      type,
      year,
      jacket,
      pants,
      memo,
    } = apiData
    const _payload = {
      ...payload,
      basting,
      customerId,
      fabricCompanyId,
      fabricId: fabricId || "",
      fittingDate,
      guest,
      guestId,
      guestName,
      orderDate,
      files,
      productId,
      seasonId,
      storeId,
      type,
      year,
      memo,
    }
    if (apiData["pants"] !== undefined) {
      /**
       * corrections: [{
       * formId: 0,
       * sequence: 0,
       * answers: [
       *  {sequence: 0, answer: ''}
       * ]
       * }]
       */
      const {
        scale,
        priceTaxIncluded,
        priceWithoutTax,
        deliveryMethod,
        sample,
        scheduledDeliveryDate,
        oldAge,
        tg,
        payments,
        button,
        threadColor,
      } = pants
      const _pants = {
        // ...apiData.pants,
        scale,
        priceTaxIncluded,
        priceWithoutTax,
        deliveryMethod,
        sample,
        scheduledDeliveryDate,
        oldAge,
        tg,
        payments,
        button,
        threadColor,
        dimensions: pants.dimensions
          .filter(dim => dim.formId)
          .map(dim => ({
            formId: dim.formId,
            sequence: dim.sequence,
            correctionValue: dim.correctionValue,
            nude: dim.nude,
            riseDimension: dim.riseDimension,
          })),
        corrections: constructAnswers(pants.corrections),
        specifications: constructAnswers(pants.specifications),
      }
      _payload.pants = _pants
    }
    if (apiData["jacket"] !== undefined) {
      const {
        scale,
        priceTaxIncluded,
        priceWithoutTax,
        deliveryMethod,
        sample,
        scheduledDeliveryDate,
        oldAge,
        tg,
        payments,
      } = jacket
      const _jacket = {
        scale,
        priceTaxIncluded,
        priceWithoutTax,
        deliveryMethod,
        sample,
        scheduledDeliveryDate,
        oldAge,
        tg,
        payments,
        specifications: constructAnswers(jacket.specifications),
        dimensions: jacket.dimensions
          .filter(dim => dim.formId)
          .map(dim => ({
            formId: dim.formId,
            sequence: dim.sequence,
            gaugeDimensions: dim.gaugeDimensions,
            correctionValue: dim.correctionValue,
            lawToGoUp: dim.lawToGoUp,
          })),
        otherDimensions: jacket.otherDimensions
          .filter(oDim => oDim.formId)
          .map(oDim => ({
            formId: oDim.formId,
            sequence: oDim.sequence,
            answer: oDim.answer,
          })),
      }
      _payload.jacket = _jacket
    }
    if (apiData.storeId === 1) setGuestHidden(0)
    if (apiData.pants === undefined) delete _payload.pants
    if (apiData.jacket === undefined) delete _payload.jacket
    setPayload(_payload)
  }
  const defineTabs = apiData => {
    const tabLabels = [
      ["pants", "トラウザーズ"],
      ["jacket", "上着"],
      // ["handwriting", "手書きノート"], ini dipindahin kebawah supaya bisa save
    ]
    const _tabs = []
    let idx = 0
    tabLabels.forEach(label => {
      if (apiData[label[0]]) {
        _tabs.push({
          index: idx,
          value: label[1],
        })
        idx++
      }
    })
    // const inspection = ["inspectionHistory", "検品記録"]
    if (apiData.status === "検品済み" || apiData.status === "完了") {
      _tabs.push({
        index: idx,
        value: "検品済み",
      })
    }

    _tabs.push({ value: "手書きノート", index: idx + 1 })

    for (let index = 0; index < _tabs.length; index++) {
      _tabs[index].checked = index === 0 ? true : false
    }

    setTabs(_tabs)
  }
  const initialize = apiData => {
    constructPayload(apiData)
    defineTabs(apiData)
  }
  /**
   * ラジオボタン = Radio
   * プルダウン : dropdown/select,
   * チェックボックス : checkbox,
   * TEXT
   */
  const fetchData = async () => {
    try {
      const res = await getEditOrderAPI(id)
      if (res.data) {
        setProductData(res.data)
        initialize(res.data)
        if (res.data.status === "検品済み" || res.data.status === "完了")
          loadInspectionHistory()
        if (res.data?.pants?.deliveryMethod)
          setPantsDeliveryMethod({
            label: res.data.pants.deliveryMethod,
            value: res.data.pants.deliveryMethod,
          })
        if (res.data?.jacket?.deliveryMethod)
          setJacketDeliveryMethod({
            label: res.data.jacket.deliveryMethod,
            value: res.data.jacket.deliveryMethod,
          })
      }
    } catch (err) {
      console.log(err)
    }
  }
  const loadCategories = async (keyword = "") => {
    const params = { keyword }
    try {
      const res = await getProductCategoryListAPI(params)
      setCategories(
        res.data
          .map(val => ({ label: val.name, value: val.id }))
          .filter(i => i.label.toLowerCase().includes(keyword.toLowerCase()))
      )
    } catch (error) {
      console.error(error)
    }
  }
  const loadInspectionHistory = async () => {
    try {
      const { data } = await getInspectionHistoryApi(id)
      setInspectionData(data)
    } catch (error) {
      console.error(error)
    }
  }
  const loadProducts = async () => {
    const params = {
      categoryId: productData.productCategoryId,
    }
    try {
      const res = await getProductListAPI(params)
      const _products = res.data.map(product => ({
        value: product.id,
        label: product.productName,
      }))
      setProducts(_products)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    loadCategories()
  }, [])
  useEffect(() => {
    if (productData && productData.productId) loadProducts()
  }, [productData])
  const loadBranch = async (keyword = "") => {
    const params = { keyword }
    const res = await BranchesAPI.getList(params)
    // const _branches =
    const _branch = res.data
      .map(b => ({
        label: b.branchName,
        value: b.id,
        org: b,
      }))
      .find(item => item.value === payload.storeId)
    setBranch(_branch)
    return res.data.map(branch => ({
      label: branch.branchName,
      value: branch.id,
      org: branch,
    }))
  }
  const loadCustomer = async (keyword = "") => {
    const params = {
      branchId: payload.storeId,
      keyword,
    }
    const res = await CompanyAPI.getList(params)
    const _customers = res.data
      .map(cust => ({
        // label: `${cust.name} ${cust.code}`,
        label: `${cust.customerName}`,
        value: cust.id,
      }))
      .filter(i => i.label.toLowerCase().includes(keyword.toLowerCase()))
    setCustomers(_customers)
    setCustomerId(
      _customers.find(item => item.value === productData.customerId) ||
        defaultSelectValue
    )
    return _customers
  }
  const loadFabricTrading = async (keyword = "") => {
    const res = await getFabricTradingListAPI()
    const _fabricTradings = res.data
      .map(fab => ({
        label: fab.name,
        value: fab.id,
        org: fab,
      }))
      .filter(i => i.label.toLowerCase().includes(keyword.toLowerCase()))
    setFabricTradings(_fabricTradings)
    return _fabricTradings
  }
  const loadFabric = async () => {
    const params = {
      fabricCompanyId: payload.fabricCompanyId,
      year: payload.year,
    }
    const res = await getFabricListAPI(params)
    const _fabrics = res.data.map(fab => ({
      label: `${fab.brand} ${fab.bunch}`,
      value: fab.id,
      org: fab,
    }))
    setFabrics(_fabrics)
    return _fabrics
  }
  const loadFabricYear = async () => {
    const res = await getFabricYearListAPI(payload.fabricCompanyId)
    const _years = res.data.map(item => ({
      label: item,
      value: item,
    }))
    const _year = _years.find(year => year.label === payload.year)
    setYears(_years)
    setYear(_year)
  }
  const loadFabricSeason = async () => {
    const res = await getFabricSeasonListAPI(payload.fabricId, payload.year)
    const _seasons = res.data.map(item => ({
      label: `${item.seasonName} ${item.seasonCode}`,
      value: item.seasonId,
    }))
    const _season = _seasons.find(season => season.value === payload.seasonId)
    setSeason(_season)
    setSeasons(_seasons)
  }
  const loadRank = async () => {
    const { fabricId: f, year: y, seasonId: sid } = payload
    const res = await getFabricRankAPI(f, y, sid)
    setPayload({
      ...payload,
      clothWidth: res?.data?.clothWidth,
      fabricRank: res?.data?.rank,
      mixedRatio: res?.data?.mixedRatio,
    })
    setRank(res.data)
  }
  useEffect(() => {
    const { fabricId, year, seasonId } = payload
    if (fabricId && year && seasonId) loadRank()
  }, [payload.fabricId, payload.year, payload.seasonId])
  const fetchTax = async () => {
    const res = await getCommonTaxAPI()
    setTax(res.data.tax)
  }
  const loadPaymentMethods = async () => {
    const res = await getPaymentMethods()
    const _paymentMethods = res.data.map(meth => ({
      value: meth.id,
      label: meth.name,
    }))
    setPaymentMethods(_paymentMethods)
  }
  const loadFileCategory = async () => {
    try {
      const { data } = await getFileCategoryApi()
      const _list = data.map(item => ({
        label: item.name,
        value: item.id,
      }))
      setFileCategoryOptions(_list)
    } catch (error) {
      console.error("Error getting file category: ", error)
    }
  }
  const loadTgTypes = async (tg, [paramType, payloadType]) => {
    try {
      const { data } = await getProductTgType(payload.productId, tg, paramType)
      if (!data.length) return
      const _dimensions = [...payload[payloadType]?.dimensions].map(item => ({
        ...item,
        nude: parseInt(
          data.find(_item => item.formId === _item.formId).defaultValue
        ),
        gaugeDimensions: parseInt(
          data.find(_item => item.formId === _item.formId).defaultValue
        ),
      }))
      setPayload({
        ...payload,
        [payloadType]: {
          ...payload[payloadType],
          dimensions: _dimensions,
        },
      })
    } catch (error) {
      console.error("Error getting tg types: ", error)
    }
  }
  const stateHandlers = {
    storeId: v => setBranch(v),
    customerId: v => setCustomerId(v),
    fabricCompanyId: v => setFabricTrading(v),
    fabricId: v => setFabric(v),
    year: v => setYear(v),
    seasonId: v => setSeason(v),
    deliveryMethod: v => setDeliveryMethodValue(v),
  }
  const handleInput = props => {
    console.log("from Index", props)
    const { e, type } = props
    const _payload = { ...payload }
    switch (type) {
      case "storeId":
      case "customerId":
      case "fabricCompanyId":
      case "fabricId":
      case "seasonId":
      case "year": {
        if (!e) {
          _payload[type] = ""
          stateHandlers[type](defaultSelectValue)
        } else {
          _payload[type] = e.value
          stateHandlers[type](e)
        }
        if (type === "storeId" && e.value && e.value === 1) {
          setGuestHidden(0)
        } else {
          setGuestHidden(1)
        }
        break
      }
      case "memo": {
        _payload[type] = e.target.value
        break
      }
      case "priceWithoutTax": {
        const value = parseInt(e) || 0
        let priceTaxIncluded = 0
        if (value) {
          priceTaxIncluded = value + value * 0.1
        }

        _payload[props.itemName][type] = value
        _payload[props.itemName]["priceTaxIncluded"] = priceTaxIncluded
        break
      }
      case "orderDate":
      case "fittingDate": {
        // _payload[type] = new Date(e).toISOString().slice(0, 10)
        _payload[type] = moment(e).format("YYYY-MM-DD")
        break
      }
      case "guestName":
      case "type": {
        _payload[type] = e.target.value
        break
      }
      case "guest": {
        _payload[type] = e.target.checked
        break
      }
      case "button":
      case "scale":
      case "threadColor": {
        _payload[props.itemName][type] = e.target.value
        break
      }
      case "deliveryMethod": {
        _payload[props.itemName][type] = e.value
        // stateHandlers[type](e)
        if (props.itemName === "pants") setPantsDeliveryMethod(e)
        else setJacketDeliveryMethod(e)
        break
      }
      case "basting": {
        _payload[type] = props.value
        break
      }
      case "sample": {
        _payload[props.itemName][type] = e.target.checked
        break
      }
      case "dimensions": {
        const { name: _key, val, obj, idx, itemName, type } = props
        const _dimensions = [...payload[props.itemName][type]]
        const _dimension = { ..._dimensions[idx] }
        switch (itemName) {
          case "jacket": {
            switch (_key) {
              case "gaugeDimensions": {
                _dimension.gaugeDimensions = val
                _dimension.lawToGoUp =
                  parseFloat(val || 0) +
                  parseFloat(_dimension.correctionValue || 0)

                break
              }
              case "correctionValue": {
                _dimension.lawToGoUp =
                  parseFloat(_dimension.gaugeDimensions || 0) +
                  parseFloat(val || 0)

                // _dimension.correctionValue = currency(val || 0)
                _dimension.correctionValue = val
                break
              }
              case "lawToGoUp": {
                _dimension.correctionValue =
                  parseFloat(val || 0) -
                  parseFloat(_dimension.gaugeDimensions || 0)

                _dimension.lawToGoUp = val
                break
              }
            }
            break
          }
          case "pants": {
            switch (_key) {
              case "nude": {
                _dimension.nude = val
                _dimension.riseDimension =
                  parseFloat(val || 0) +
                  parseFloat(_dimension.correctionValue || 0)

                break
              }
              case "correctionValue": {
                _dimension.riseDimension =
                  parseFloat(_dimension.nude || 0) + parseFloat(val || 0)
                _dimension.correctionValue = val
                break
              }
              case "riseDimension": {
                _dimension.correctionValue =
                  parseFloat(val || 0) - parseFloat(_dimension.nude || 0)

                _dimension.riseDimension = val
                break
              }
            }
            break
          }
        }
        _dimensions[idx] = _dimension
        _payload[itemName][type] = _dimensions
        break
      }
      case "specifications":
      case "corrections": {
        const { itemName, index, answer } = props
        const _payloadData = [...payload[itemName][type]]
        _payloadData[index] = answer
        _payload[itemName][type] = _payloadData
        break
      }
      case "otherDimensions": {
        _payload[props.itemName][type][props.index] = props.data
        break
      }
      case "tg": {
        _payload[props.itemName][type] = e.target.value
        break
      }
      case "payments": {
        const _payments = [...payload[props.itemName][type]]
        _payments.push(props.data)
        _payload[props.itemName][type] = _payments
        break
      }
      case "oldAge": {
        _payload[props.itemName][type] = parseInt(props.e.target.value)
        break
      }
      case "scheduledDeliveryDate": {
        _payload[props.itemName][type] = moment(props.e[0]).format("YYYY-MM-DD")
        //  new Date(props.e[0])
        //   .toISOString()
        //   .slice(0, 10)
        break
      }
      case "fileCategoryName": {
        console.log(e)
        if (!e) setFileCategoryValue("")
        setFileCategoryValue(e)
        break
      }
      case "fileCategory": {
        setFile(e.target.files[0])
        break
      }
      case "item": {
        break
      }
    }
    setPayload(_payload)
  }
  // component mounts
  useEffect(() => {
    if (id) {
      fetchData()
      loadBranch()
      loadFabricTrading()
      loadCustomer()
      fetchTax()
      loadPaymentMethods()
      loadFileCategory()
    }
  }, [])
  // State managements for selects
  useEffect(() => {
    if (productData && branches.length) {
      const _branch = branches.find(
        ({ value }) => value === productData.storeId
      )
      setBranch(_branch)
    }
  }, [productData, branches])
  useEffect(() => {
    if (productData && customerIds.length && productData.customerId) {
      const _customerId = customerIds.find(
        ({ value }) => value === productData.customerId
      )
      setCustomerId(_customerId)
    }
  }, [productData, customerIds])
  useEffect(() => {
    if (productData && fabricTradings.length) {
      const _fabricTrading = fabricTradings.find(
        ({ value }) => value === productData.fabricCompanyId
      )
      setFabricTrading(_fabricTrading)
    }
  }, [productData, fabricTradings])
  useEffect(() => {
    if (productData && fabrics.length) {
      const _fabric = fabrics.find(
        ({ value }) => value === productData.fabricId
      )
      setFabric(_fabric)
    }
  }, [productData, fabrics])
  // api calls
  useEffect(() => {
    loadCustomer()
  }, [branch])
  useEffect(() => {
    if (year?.value && fabricTrading?.value) {
      loadFabric()
    }
  }, [year, fabricTrading])
  // useEffect(() => {
  //   const params = {
  //     fabricCompanyId: payload.fabricCompanyId,
  //     year: payload.year,
  //   }
  //   loadFabric(params)
  // }, [payload.fabricCompanyId, payload.year])
  useEffect(() => {
    if (payload.fabricCompanyId) {
      loadFabricYear()
    }
  }, [payload.fabricCompanyId])
  useEffect(() => {
    if (payload.fabricId && payload.year) {
      loadFabricSeason()
    }
  }, [payload.fabricId, payload.year])

  const [isSubmitting, setIsSubmitting] = useState(false)
  const onSubmitPress = () => {
    setIsSubmitting(true)
    const temp = [...tabs]
    temp.forEach((tab, i) => {
      if (i === tabs.length - 1) {
        tab.checked = true
      } else {
        tab.checked = false
      }
    })
    setActiveTab(temp)

    setTimeout(() => {
      onSubmit()
    }, 500)
  }
  const onSubmit = async () => {
    try {
      const formData = new FormData()
      const config = {
        "Content-Type": "multipart/formdata",
      }

      for (const key in payload) {
        switch (key) {
          case "jacket":
          case "pants": {
            for (const _key in payload[key]) {
              switch (_key) {
                case "dimensions":
                case "otherDimensions":
                case "corrections":
                case "specifications":
                case "payments": {
                  if (payload[key][_key].length) {
                    payload[key][_key].forEach((item, idx) => {
                      for (const __key in item) {
                        switch (__key) {
                          case "answers": {
                            item[__key].forEach((_item, _idx) => {
                              for (const ___key in _item) {
                                const ansKey = `${key}.${_key}[${idx}].${__key}.${_idx}.${___key}`
                                // key: jacket, _key: specifications, idx: 0, __key: answers, _idx: 0, ___key: answer/sequnce
                                // jacket.specifications[0].answers[0].answer
                                const ansVal = _item[___key]
                                formData.append(ansKey, ansVal || "")
                              }
                            })
                            break
                          }
                          default: {
                            const fKey = `${key}.${_key}[${idx}].${__key}`
                            const fVal = item[__key]
                            formData.append(fKey, fVal || "")
                          }
                        }
                      }
                    })
                  }
                  break
                }
                default: {
                  formData.append(`${key}.${_key}`, payload[key][_key] || "")
                }
              }
            }
            break
          }
          case "files": {
            if (payload[key].length) {
              payload[key].forEach((item, idx) => {
                for (const _key in item) {
                  formData.append(`${key}[${idx}].${_key}`, item[_key] || "")
                }
              })
            }
            break
          }
          default: {
            formData.append(key, payload[key] || "")
          }
        }
      }
      const getCanvas = await getCanvasRef.current.saveCanvas()

      let handwritings
      setTimeout(async () => {
        if (getCanvas.details) {
          handwritings = getCanvas
        } else {
          handwritings = {
            details: [],
          }
        }

        if (handwritings.details) {
          handwritings.details.forEach((dtl, idx) => {
            formData.append(
              `handwriting.details[${idx}].json`,
              JSON.stringify(dtl.json || "[]")
            )
            formData.append(
              `handwriting.details[${idx}].image`,
              dtl.image || ""
            )
          })
        }

        // console.log(handwritings)
        // console.log(getCanvas?.canvas.length)

        // for (const [key, value] of formData.entries()) {
        //   console.log({ [key]: value })
        // }
        // debugging;

        let data = await postUpdateOrderApi(id, formData, config)
        if (data.status === 200) {
          setIsSubmitting(false)
          toast.success(`保存しました。`)
          setTimeout(() => {
            history.push("/orders")
          }, 500)
        }
      }, (getCanvas?.details.length || 2) * 1000)
    } catch (error) {
      setIsSubmitting(false)
      for (let i in error?.response?.data?.errors) {
        for (const [key, value] of Object.entries(
          Object.entries(error.response.data.errors[i])
        )) {
          toast.error(`${value[0]}: ${value[1]}`)
        }
      }
    }
  }
  const onAddFile = () => {
    if (!fileCategoryValue?.value || !file) return
    const _fileInfo = {
      categoryId: fileCategoryValue.value,
      categoryName: fileCategoryValue.label,
      fileName: file.name,
      file: file,
    }
    // console.log(payload);
    // return;
    const _files = [...payload.files, _fileInfo]
    const _payload = { ...payload, files: _files }
    setPayload(_payload)

    // will show success add file temporary until save to api
    let messageSuccessAddFile = (
      <p>
        ファイルはまだ保存されていません。
        <br />
        ポップアップを閉じて「保存」ボタンをクリックして下さい。
      </p>
    )
    toast.warning(messageSuccessAddFile)

    setTimeout(() => {
      setFileCategoryValue("")
      setFile(null)
      const fileInputEl = document?.getElementById("fileInput")
      fileInputEl.value = null
    }, 10)
  }
  const onDeleteFile = idx => {
    const _files = [...payload.files]
    _files.splice(idx, 1)
    setPayload({ ...payload, files: _files })

    // will show success delete file temporary until save to api
    let messageSuccessDeleteFile = (
      <p>
        ファイルはまだ削除されていません。
        <br />
        ポップアップを閉じて「保存」ボタンをクリックして下さい。
      </p>
    )
    toast.warning(messageSuccessDeleteFile)
  }
  const onDownloadFile = href => {
    const link = document.createElement("a")
    link.href = href
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  const onShip = async () => {
    try {
      const data = await shipOrderApi(id)
      history.push("/orders")
    } catch (error) {
      console.log(error)
    }
  }
  const onCancel = () => {
    // showing popup modal
    setModalCancel(!modalCancel)
  }
  const [modalCancel, setModalCancel] = useState(false)
  const onSubmitCancel = async () => {
    try {
      const res = await patchCancelOrder(id)
      history.push("/orders")
    } catch (err) {}
  }
  const onPrint = async () => {
    try {
      const { data } = await getPrintOrder(id)
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "application/pdf" })
      )
      link.setAttribute(
        "download",
        "order_report" + new Date().getTime() + ".pdf"
      )
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.log(error)
    }
  }
  const onTgBlur = (e, type) => {
    const _tg = e?.target?.value
    if (!_tg) return
    return loadTgTypes(_tg, type)
  }
  const config = {
    loadBranch,
    loadCategories,
    loadCustomer,
    branch,
    branches,
    customerId,
    customerIds,
    handleInput,
    loadFabricTrading,
    fabricTrading,
    fabricTradings,
    fabric,
    loadFabric,
    fabrics,
    year,
    years,
    season,
    seasons,
    rank,
    paymentMethods,
    deliveryMethodValue,
    productData,
    pantsDeliveryMethod,
    jacketDeliveryMethod,
    setPantsDeliveryMethod,
    setJacketDeliveryMethod,
    guestHidden,
    customers,
    setCustomers,
    onTgBlur,
  }
  return (
    <div className="page-content">
      {productData && categories && (
        <Container fluid>
          {/* <Breadcrumb title={"受注一覧"} breadcrumbList={[]} /> */}
          <Breadcrumb title={"受注詳細"} breadcrumbList={[]} />
          <Card>
            <CardBody>
              <Row>
                <Col sm={1} style={{ placeSelf: "center" }}>
                  <p className="mb-0">商品</p>
                </Col>
                <Col sm={3}>
                  <SelectBox
                    isDisabled
                    options={categories}
                    value={categories.find(
                      item => item.value === productData.productCategoryId
                    )}
                    onChange={() => null}
                  />
                </Col>
                <Col sm={3}>
                  <SelectBox
                    isDisabled
                    options={products}
                    value={products.find(
                      item => item.value === productData.productId
                    )}
                    onChange={() => null}
                  />
                </Col>
              </Row>
              <Row className="mt-4 justify-content-end">
                <Col sm={2}>
                  {/* キャンセル: cancel => goes  back to order-list */}
                  <SButton
                    // style={{ width: 150 }}
                    className="button w-100"
                    onClick={() => onCancel()}
                  >
                    注文取消
                  </SButton>
                </Col>
                <Col sm={2}>
                  {/* 印刷: printing */}
                  <SButton
                    // style={{ width: 150 }}
                    className="button w-100"
                    onClick={() => onPrint()}
                  >
                    印刷
                  </SButton>
                </Col>
                {productData?.status === "検品済み" && (
                  <Col sm={2}>
                    {/* 出荷: shipping, only shows  when the status is "inspected" */}
                    <SButton className="button w-100" onClick={onShip}>
                      出荷
                    </SButton>
                  </Col>
                )}
                <Col sm={2}>
                  <SButton className="button w-100" onClick={openFileModal}>
                    ファイル管理
                  </SButton>
                </Col>
                <Col sm={2}>
                  <SButton
                    loading={isSubmitting}
                    className="button w-100"
                    onClick={onSubmitPress}
                  >
                    保存
                  </SButton>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {productData && payload && (
            <>
              <div className="d-flex my-3">
                {tabs?.map(tab => {
                  const style = tab.checked ? "button-active" : "button"
                  return (
                    <SButton
                      key={tab.index}
                      style={{ width: 150, borderRadius: 0 }}
                      className={`${style}`}
                      onClick={() => {
                        const temp = [...tabs]

                        temp.forEach(t => {
                          if (tab.value === t.value) {
                            t.checked = true
                          } else {
                            t.checked = false
                          }
                        })

                        setTabs(temp)
                      }}
                    >
                      {tab.value}
                    </SButton>
                  )
                })}
              </div>
              <div className="mt-4">
                {tabs.map(tab => (
                  <>
                    {tab.value === "トラウザーズ" && tab.checked ? (
                      <TrousersTab
                        config={config}
                        data={productData}
                        payload={payload}
                      />
                    ) : tab.value === "上着" && tab.checked ? (
                      <JacketTab
                        config={config}
                        data={productData}
                        payload={payload}
                      />
                    ) : tab.value === "手書きノート" && tab.checked ? (
                      <TabHandwritingNotebook
                        data={productData}
                        setCanvas={e => setCanvas(e)}
                        trigger={trigger}
                        ref={getCanvasRef}
                      />
                    ) : tab.value === "検品済み" && tab.checked ? (
                      <TabInspectionHistory data={inspectionData} />
                    ) : (
                      ""
                    )}
                  </>
                ))}
              </div>
            </>
          )}
        </Container>
      )}
      <ReactStrapModal isOpen={modalCancel} size="sm" toggle={onCancel}>
        <ModalHeader>こちらの注文を取り消ししますか</ModalHeader>
        <ModalFooter>
          <Button onClick={() => onSubmitCancel()} className="button">
            はい
          </Button>
          <Button onClick={() => onCancel()} className="button">
            いいえ
          </Button>
        </ModalFooter>
      </ReactStrapModal>

      <FileManagerModal
        modalOpen={fileModalOpen}
        closeModal={closeFileModal}
        payload={payload}
        fileCategoryOptions={fileCategoryOptions}
        fileCategoryValue={fileCategoryValue}
        onDeleteFile={onDeleteFile}
        handleInput={(e, type) => handleInput({ e, type })}
        onAddFile={onAddFile}
      />
    </div>
  )
}
